export default "__VITE_ASSET__BBW5daoX__"